import React from 'react';
import { Box, Fab, Slide, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import Navbar from './Navbar';
import HeroSection from '../sections/HeroSection';
import ServicesSection from '../sections/ServicesSection';
import ProjectsSection from '../sections/ProjectsSection';
import AboutSection from '../sections/AboutSection';
import ContactSection from '../sections/ContactSection';
import Footer from '../components/Footer';

function ScrollTop() {
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 100 });

  return (
    <Slide in={trigger} direction="up">
      <Box
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        role="presentation"
        sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 10 }}
      >
        <Fab color="primary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </Box>
    </Slide>
  );
}

const SinglePageLayout = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <Navbar />
    <Box component="main" sx={{ flexGrow: 1 }}>
      <HeroSection />
      <ServicesSection />
      <ProjectsSection />
      <AboutSection />
      <ContactSection />
    </Box>
    <Footer />
    <ScrollTop />
  </Box>
);

export default SinglePageLayout;
